import React from 'react';

const SMSTable = ({ conversations, onRowClick, formatPhoneNumber }) => {
  if (conversations.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded p-6 text-center">
        <p className="text-gray-600 text-base font-medium mb-2">No SMS conversations found</p>
        <p className="text-gray-600 text-sm">SMS conversations will appear here when customers text your assistant.</p>
      </div>
    );
  }

  return (
    <div>
      <p className="text-gray-600 text-sm mb-2 text-center">💬 Click on any row to view the SMS conversation</p>
      <div className="bg-white border border-gray-200 rounded overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-gray-800">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-100 uppercase tracking-wider w-1/2">
                  Date & Time
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-100 uppercase tracking-wider w-1/3">
                  Phone Number
                </th>
                <th className="px-6 py-4 text-center text-xs font-bold text-gray-100 uppercase tracking-wider w-1/6">
                  📱
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {conversations.map((conversation, index) => (
                <tr 
                  key={conversation.conversation_id}
                  className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 cursor-pointer transition-colors ${index > 0 ? 'border-t border-gray-200' : ''}`}
                  onClick={() => onRowClick(conversation.conversation_id)}
                >
                  <td className="px-6 py-4">
                    <div className="text-xs text-gray-900 leading-tight whitespace-nowrap">
                      <div>{new Date(conversation.start_time * 1000).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric'
                      })}</div>
                      <div className="text-xs text-gray-600">{new Date(conversation.start_time * 1000).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true
                      })}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">
                      {formatPhoneNumber(conversation.from_number)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <div className="text-sm text-gray-900 capitalize">
                      {conversation.status}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SMSTable;